import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  TextField,
  Button,
} from '@mui/material';

const ApprovalModal = ({
  open,
  onClose,
  onSubmit,
  plan,
  title,
  approveLabel = "Approve and Submit to Provider",
  returnLabel = "Return to Employee for Additional Needed Info",
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [remarks, setRemarks] = useState('');
  const [errors, setErrors] = useState({ option: false, remarks: false });

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setErrors((prev) => ({ ...prev, option: false }));
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
    setErrors((prev) => ({ ...prev, remarks: false }));
  };

  const handleSubmit = () => {
    const hasErrors = {
      option: !selectedOption,
      remarks: !remarks.trim(),
    };
    setErrors(hasErrors);

    if (!hasErrors.option && !hasErrors.remarks) {
      onSubmit({ option: selectedOption, remarks });
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500, // Increased width
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          {title || `${plan} Plan Approval`}
        </Typography>
        <FormControl component="fieldset" sx={{ marginBottom: 2 }}>
          <RadioGroup
            row
            value={selectedOption}
            onChange={handleOptionChange}
            aria-label="approval options"
          >
            <FormControlLabel
              value="Approved"
              control={<Radio />}
              label={approveLabel}
            //   required
            />
            <FormControlLabel
              value="Return"
              control={<Radio />}
              label={returnLabel}
            //   required
            />
          </RadioGroup>
          {errors.option && (
            <Typography color="error" variant="caption">
              Please select an option.
            </Typography>
          )}
        </FormControl>
        <TextField
          label="Remarks"
          variant="outlined"
          fullWidth
        //   required
          value={remarks}
          onChange={handleRemarksChange}
          error={errors.remarks}
          helperText={errors.remarks && 'Remarks are required.'}
          multiline
          rows={3}
          sx={{ marginBottom: 2 }}
        />
        <Box display="flex" justifyContent="space-between" mt={2}>
          <Button
            variant="outlined"
            // color="secondary"
            onClick={onClose}
            sx={{ width: '48%' }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ width: '48%' }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ApprovalModal;
